// extracted by mini-css-extract-plugin
module.exports = {"btn-switch":"btn-switch","is-active":"is-active"};